export function sideMapping(side: string | null): '1' | '2' | undefined {
  if (side === 'BUY') return '1'
  if (side === 'SELL') return '2'
  return undefined
}

export function sideReverseMapping(
  fixSide: '1' | '2' | null,
  viceVersa = false
): 'BUY' | 'SELL' | undefined {
  if (fixSide === '1') return viceVersa ? 'SELL' : 'BUY'
  if (fixSide === '2') return viceVersa ? 'BUY' : 'SELL'
  return undefined
}

export const invertSide = (side?: string | null): 'BUY' | 'SELL' | undefined => {
  if (side === 'BUY') return 'SELL'
  if (side === 'SELL') return 'BUY'
  return undefined
}
